import React from 'react'
import PropTypes from 'prop-types'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import { Link } from 'react-router-dom'
import { Button } from '../../../features/section-components/Button'
import styles from '../MyAccount.module.scss'

function AccountItemContainer({
  t, label, value, onClick, mobile, renderData, button, link
}) {
  if (mobile) {
    return (
      <div className={styles['mobile-account-item-container']} data-testid="renderData">
        {renderData(t(label), value)}
        {((button && link)
          && (
            <Link
              to={link}
              style={{ display: 'inline-block', width: '100%' }}
              onClick={onClick}
            >
              <Button
                text={t('button-edit')}
                buttonStyle="cta-grey-oval-edit-profile-info-mobile"
                onClick={onClick}
                endIcon={<ArrowForwardIcon />}
                iconSize="small"
              />
            </Link>
          )
        )}
        {((button && !link)
        && (
        <Button
          text={t('button-edit')}
          buttonStyle="cta-grey-oval-edit-profile-info-mobile"
          onClick={onClick}
          endIcon={<ArrowForwardIcon />}
          iconSize="small"
        />
        )
      )}
      </div>
    )
  }
  return (
    <div className={styles['account-item-container']} data-testid="renderData">
      {renderData(t(label), value)}
      {((button && link)
        && (
          <Link
            to={link}
            style={{ display: 'inline-block' }}
            onClick={onClick}
          >
            <Button
              text={t('button-edit')}
              buttonStyle="cta-grey-oval-edit-profile-info"
              onClick={onClick}
              endIcon={<ArrowForwardIcon />}
              iconSize="small"
            />
          </Link>
        )
      )}
      {((button && !link)
        && (
        <Button
          text={t('button-edit')}
          buttonStyle="cta-grey-oval-edit-profile-info"
          onClick={onClick}
          endIcon={<ArrowForwardIcon />}
          iconSize="small"
        />
        )
      )}
      {(!button
        && (
          <Button
            buttonStyle="hold-space"
          />
        )
      )}
    </div>
  )
}

AccountItemContainer.propTypes = {
  t: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  renderData: PropTypes.func.isRequired,
  mobile: PropTypes.bool,
  link: PropTypes.string.isRequired,
  button: PropTypes.bool
}

AccountItemContainer.defaultProps = {
  mobile: false,
  button: false
}

export default AccountItemContainer
